module.exports = __webpack_public_path__ + "static/img/PGE_invite_popup.f1498bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/PGE_invite_popup.png
// module id = F3DR
// module chunks = 0